import HttpClient from '../../Api/HttpClient';

export default function archiveTask({ onSuccess } = {}) {
  return {
    mutationFn: async ({ taskId }) => {
      const { data } = await HttpClient.updateProject({
        id: taskId,
        data: { archived: 'True' },
      });

      return data;
    },
    onSuccess,
  };
}
